import React from "react";
import { Link } from "react-router-dom";

export function FooterMain() {
  const year = new Date().getFullYear();

  const footerLinks = [
    { text: "Terms & Conditions", link: "/termsandconditions" },
    { text: "Privacy Policy", link: "/privacypolicy" },
  ];

  return (
    <footer
      className="relative w-full bg-black text-slate-300 py-[40px] 
                 overflow-hidden"
    >
      {/* MOBILE (< md) */}
      <div className="flex flex-col items-center justify-center md:hidden">
        <div className="relative z-10 flex gap-6 mb-4">
          <a
            href="https://www.youtube.com/@floatkeygames"
            target="_blank"
            rel="noreferrer"
            className="group transition-transform duration-300 hover:scale-110"
          >
            <div className="relative">
              <span
                className="absolute inset-0 rounded-full bg-indigo-500/20 blur-md 
                           opacity-0 group-hover:opacity-100 transition duration-500"
              />
              <img
                src="/assets/images/youtube2.png"
                alt="YouTube"
                className="relative w-[32px] h-[32px] object-contain 
                           brightness-90 group-hover:brightness-110 transition duration-300"
              />
            </div>
          </a>
        </div>

        <div className="relative z-10 flex flex-col items-center text-center mb-8">
          <h2
            className="text-[15px] md:text-2xl font-bold tracking-[0.25em] 
                       bg-gradient-to-r from-indigo-400 via-purple-400 to-blue-400 
                       text-transparent bg-clip-text 
                       drop-shadow-[0_0_10px_rgba(99,102,241,0.5)]"
          >
            FLOATKEYGAMES
          </h2>
          <p className="mt-2 text-slate-400 text-[10px] tracking-widest">
            INDIE STUDIO · CREATING DREAMY WORLDS
          </p>
        </div>

        <div
          className="relative z-10 flex flex-wrap justify-center gap-8 
                     text-[12px] text-slate-400 mb-8"
        >
          {footerLinks.map((item) => (
            <Link
              key={item.text}
              to={item.link}
              className="relative group hover:text-white transition duration-300"
            >
              {item.text}
              <span
                className="absolute left-0 bottom-0 w-0 h-[2px] 
                           bg-gradient-to-r from-indigo-400 to-purple-400 
                           group-hover:w-full transition-all duration-300"
              />
            </Link>
          ))}
        </div>

        <p className="relative z-10 text-[10px] text-slate-500 tracking-wide">
          © {year} FLOATKEYGAMES. All rights reserved.
        </p>
      </div>

      {/* TABLET (md ≤ width < lg) */}
      <div className="hidden md:flex lg:hidden flex-col items-center justify-center">
        <div className="relative z-10 flex gap-6 mb-4">
          <a
            href="https://www.youtube.com/@floatkeygames"
            target="_blank"
            rel="noreferrer"
            className="group transition-transform duration-300 hover:scale-110"
          >
            <div className="relative">
              <span
                className="absolute inset-0 rounded-full bg-indigo-500/20 blur-md 
                           opacity-0 group-hover:opacity-100 transition duration-500"
              />
              <img
                src="/assets/images/youtube2.png"
                alt="YouTube"
                className="relative w-[38px] h-[38px] object-contain 
                           brightness-90 group-hover:brightness-110 transition duration-300"
              />
            </div>
          </a>
        </div>

        <div className="relative z-10 flex flex-col items-center text-center mb-8">
          <h2
            className="text-[18px] font-bold tracking-[0.25em] 
                       bg-gradient-to-r from-indigo-400 via-purple-400 to-blue-400 
                       text-transparent bg-clip-text 
                       drop-shadow-[0_0_10px_rgba(99,102,241,0.5)]"
          >
            FLOATKEYGAMES
          </h2>
          <p className="mt-2 text-slate-400 text-[13px] tracking-widest">
            INDIE STUDIO · CREATING DREAMY WORLDS
          </p>
        </div>

        <div
          className="relative z-10 flex flex-wrap justify-center gap-8 
                     text-[13px] text-slate-400 mb-8"
        >
          {footerLinks.map((item) => (
            <Link
              key={item.text}
              to={item.link}
              className="relative group hover:text-white transition duration-300"
            >
              {item.text}
              <span
                className="absolute left-0 bottom-0 w-0 h-[2px] 
                           bg-gradient-to-r from-indigo-400 to-purple-400 
                           group-hover:w-full transition-all duration-300"
              />
            </Link>
          ))}
        </div>

        <p className="relative z-10 text-[11px] text-slate-500 tracking-wide">
          © {year} FLOATKEYGAMES. All rights reserved.
        </p>
      </div>

      {/* DESKTOP (≥ lg) */}
      <div className="hidden lg:flex flex-col items-center justify-center">
        <div className="relative z-10 flex gap-6 mb-4">
          <a
            href="https://www.youtube.com/@floatkeygames"
            target="_blank"
            rel="noreferrer"
            className="group transition-transform duration-300 hover:scale-110"
          >
            <div className="relative">
              <span
                className="absolute inset-0 rounded-full bg-indigo-500/20 blur-md 
                           opacity-0 group-hover:opacity-100 transition duration-500"
              />
              <img
                src="/assets/images/youtube2.png"
                alt="YouTube"
                className="relative w-[38px] h-[38px] object-contain 
                           brightness-90 group-hover:brightness-110 transition duration-300"
              />
            </div>
          </a>
        </div>

        <div className="relative z-10 flex flex-col items-center text-center mb-8">
          <h2
            className="text-[18px] font-bold tracking-[0.25em] 
                       bg-gradient-to-r from-indigo-400 via-purple-400 to-blue-400 
                       text-transparent bg-clip-text 
                       drop-shadow-[0_0_10px_rgba(99,102,241,0.5)]"
          >
            FLOATKEYGAMES
          </h2>
          <p className="mt-2 text-slate-400 text-[13px] tracking-widest">
            INDIE STUDIO · CREATING DREAMY WORLDS
          </p>
        </div>

        <div
          className="relative z-10 flex flex-wrap justify-center gap-8 
                     text-[13px] text-slate-400 mb-8"
        >
          {footerLinks.map((item) => (
            <Link
              key={item.text}
              to={item.link}
              className="relative group hover:text-white transition duration-300"
            >
              {item.text}
              <span
                className="absolute left-0 bottom-0 w-0 h-[2px] 
                           bg-gradient-to-r from-indigo-400 to-purple-400 
                           group-hover:w-full transition-all duration-300"
              />
            </Link>
          ))}
        </div>

        <p className="relative z-10 text-[11px] text-slate-500 tracking-wide">
          © {year} FLOATKEYGAMES. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default FooterMain;
